module.exports = __webpack_public_path__ + "img/egg.4493f6f2.svg";